import INGREDIENT_KEYWORDS_TRANSFER_INITIAL_STATE from './ingredient-keywords-transfer-initial-state'
import INGREDIENT_MAIN_KEYWORDS_INITIAL_STATE from './ingredient-main-keywords-initial-state'
import INGREDIENT_SUPPORTING_KEYWORDS_INITIAL_STATE from './ingredient-supporting-keywords-initial-state'

const INGREDIENT_KEYWORDS_INITIAL_STATE = {
  main: INGREDIENT_MAIN_KEYWORDS_INITIAL_STATE,
  supporting: INGREDIENT_SUPPORTING_KEYWORDS_INITIAL_STATE,
  transfer: INGREDIENT_KEYWORDS_TRANSFER_INITIAL_STATE,
}

export default INGREDIENT_KEYWORDS_INITIAL_STATE
